import $ from "jquery";
import { fabric } from "fabric";
import {
    Vector3,
    Box3
} from "three";

var currentColorPart;
var texts = [];
var images = [];
var arrayGroupLogos = [];
var corGolaArray = [];
var corMangaArray = [];
var corCamisaArray = [];
var corShortArray = [];
var corMeiaArray = [];
var corOutrosArray = [];
var uniCorGolaArray = [];
var uniCorMangaArray = []
var uniCorCamisaArray = [];
var uniCorcorShortArray = [];
var uniCorcorMeiaArray = [];
var uniCorcorOutrosArray = [];
var gradientArray = [];

function addColorSvgIframe() {

    $(".color-iframe-main").remove();
    $(".cor-tabela").remove();
    $(".thumb-logo-iframe").remove();
    $(".iframe-text-edit").remove();

    corGolaArray = [];
    corMangaArray = [];
    corCamisaArray = [];
    corShortArray = [];
    corMeiaArray = [];
    corOutrosArray = [];

    uniCorGolaArray = [];
    uniCorMangaArray = [];
    uniCorCamisaArray = [];
    uniCorcorShortArray = [];
    uniCorcorMeiaArray = [];
    uniCorcorOutrosArray = [];
    gradientArray = [];

    // Limpa arrays no window para o React saber que resetou
    window.uniCorGolaArray = [];
    window.uniCorCamisaArray = [];
    window.uniCorMangaArray = [];
    window.uniCorcorShortArray = [];
    window.uniCorcorMeiaArray = [];
    window.uniCorcorOutrosArray = [];
    window.corGolaArray = [];
    window.corCamisaArray = [];
    window.corMangaArray = [];
    window.corShortArray = [];
    window.corMeiaArray = [];
    window.corOutrosArray = [];

    texts = [];
    images = [];

    const topGroup = [];

    window.fabricCanvas.getObjects().forEach(obj => {
        if (obj.id != "bk" && obj.id != "BK")
            topGroup.push(obj);
    });

    fabric.loadSVGFromURL("https://nfghuenhuaecfyccyaib.supabase.co/storage/v1/object/public/cores/" + window.userIDIframe + "?" + Math.random(), function (objects, options) {
        const colors = new Set();

        if (objects) {
            objects.forEach(obj => {
                if (!obj.fill.type) {
                    if (obj.fill && obj.fill !== 'none') colors.add(obj.fill);
                    if (obj.stroke && obj.stroke !== 'none') colors.add(obj.stroke);
                }
            });
        }

        const arrayColors = Array.from(colors);

        window.setRawColors(arrayColors)

        for (var i = 0; i < arrayColors.length; i++) {

            const elem = "<div class='cor-tabela' style='background-color: " + arrayColors[i] + "'>" +
                "</div>";

            $("#cores-iframe-table-list").append(elem);

            const elem2 = "<div class='cor-tabela-grad' style='background-color: " + arrayColors[i] + "'>" +
                "</div>";

            const elem3 = "<div class='cor-tabela2' style='background-color: " + arrayColors[i] + "'>" +
                "</div>";

            //$("#input-color-table").append(elem3);

            $("#cores-iframe-table-list-grad").append(elem2);
        }

        getColorByPart(topGroup, "list-colors-iframe")
    })
}

function extractObjects(obj, results = { colors: [], texts: [], images: [] }) {

    if (!obj) return results;



    if (obj.type === "group") {
        if (obj.id && (String(obj.id).toLowerCase().includes("logo"))) {
            // Se o grupo contém MAIS DE UMA imagem (ex: <g id="logos"> com
            // vários <image>), cada uma é um logo separado — não empilha o
            // grupo inteiro como um único item do menu. Grupo com uma única
            // imagem (ou conteúdo misto) continua indo inteiro.
            const childImages = obj.getObjects().filter(child => child.type === "image");
            if (childImages.length > 1) {
                childImages.forEach(child => results.images.push(child));
            } else {
                results.images.push(obj);
            }
        } else
            obj.getObjects().forEach(child => extractObjects(child, results));

    } else {

        // Cores
        if (obj.fill && obj.fill !== "#CCCCCC" && obj.fill !== "#B3B3B3" && !results.colors.includes(obj.fill) && !obj["xlink:href"])
            results.colors.push(obj.fill);

        // Textos
        if (obj.type.includes("text")) {
            obj.iniScale = obj.scaleX;
            results.texts.push(obj);
        }

        // Imagens: QUALQUER objeto do tipo image (SVG <image>) entra no menu
        // de logos com opções de edição — inclusive sem id "logo" no SVG.
        if (obj.type === "image" || (obj.id && String(obj.id).toLowerCase().includes("logo"))) {
            results.images.push(obj);
        }
    }

    return results;
}

function gradientToAverageColor(gradient) {
    const stops = Object.values(gradient.colorStops);

    let r = 0, g = 0, b = 0;

    stops.forEach(stop => {
        const rgb = fabric.Color.fromRgba(stop.color)
            .toRgb()
            .match(/\d+/g)
            .map(Number);

        r += rgb[0];
        g += rgb[1];
        b += rgb[2];
    });

    const n = stops.length;

    return {
        r: Math.round(r / n),
        g: Math.round(g / n),
        b: Math.round(b / n)
    };
}



function extractObjectsColors(obj, type, results = { colors: [], texts: [], images: [] }) {
    if (!obj) return results;

    if (obj.type === "group") {
        obj.getObjects().forEach(child => extractObjectsColors(child, type, results));
    } else {

        if (!obj.type.includes("text") && !obj.type.includes("image") && !obj.fill.type) {

            if (obj.id) {
                var objId = String(obj.id).toLowerCase();
                if (!objId.includes("bk") && !objId.includes("logo")) {
                    if (objId.includes("gola")) {
                        corGolaArray.push(obj);
                    } else if (objId.includes("camisa")) {
                        corCamisaArray.push(obj);
                    } else if (objId.includes("calcao")) {
                        corShortArray.push(obj);
                    } else if (objId.includes("meia")) {
                        corMeiaArray.push(obj);
                    } else if (objId.includes("manga")) {
                        corMangaArray.push(obj);
                    } else {
                        corOutrosArray.push(obj)
                    }

                }

            } else {
                corOutrosArray.push(obj)
            }
        } else if (!obj.type.includes("text") && !obj.type.includes("image")) {

            if (obj.fill.type == "linear") {

                /*const rgb = gradientToAverageColor(obj.fill);

                obj.fill = rgbObjToString(rgb);

                corOutrosArray.push(obj)*/

                obj.gradID = gradientArray.length;
                gradientArray.push(obj)
            }
        }

        /*if (obj.id != "LD" && obj.id != "LE" && obj.id != "MD" && obj.id != "ME" && obj.id != "FRENTE" && obj.id != "COSTA" && obj.id != "NU" && obj.id != "NO" && !obj.id.includes("LOGO") && !obj.type.includes("text")) {
            if (type == "camisa") {//&& !obj.id.includes("detalhe")
                if (!obj.fill.type)
                    corCamisaArray.push(obj)
            } else if (type == "short") {
                if (!obj.fill.type)
                    corShortArray.push(obj)
            } else if (type == "meia") {
                if (!obj.fill.type)
                    corMeiaArray.push(obj)
            } else if (type == "gola") {
                if (!obj.fill.type)
                    corGolaArray.push(obj)
            } else {
                if (!obj.fill.type)
                    corOutrosArray.push(obj)
            }
        }*/
    }

    return results;
}

function rgbStringToObj(rgb) {
    const match = rgb.match(/\d+/g);
    if (!match || match.length < 3) return null;

    return {
        r: Number(match[0]),
        g: Number(match[1]),
        b: Number(match[2])
    };
}

function colorDistance(c1, c2) {

    return Math.sqrt(
        (c1.r - c2.r) ** 2 +
        (c1.g - c2.g) ** 2 +
        (c1.b - c2.b) ** 2
    );
}

function rgbObjToString(c) {
    return `rgb(${c.r}, ${c.g}, ${c.b})`;
}

function groupColorsWithMap(objects, threshold = 8) {
    const groups = [];

    objects.forEach(obj => {
        if (!obj.fillObj) return;

        let group = groups.find(g =>
            colorDistance(obj.fillObj, g.rep) <= threshold
        );

        if (!group) {
            group = {
                rep: obj.fillObj,
                items: []
            };
            groups.push(group);
        }

        group.items.push(obj);
    });

    return groups;
}

function applyGroupedColors(groups) {
    groups.forEach(group => {
        const colorStr = rgbObjToString(group.rep);

        group.items.forEach(obj => {
            obj.set("fill", colorStr);
            obj.set("fillIni", colorStr);
        });
    });
}

function organizeColors(array1, array2, id, part) {

    if (array1.length == 0) {
        $(id).parent().remove();
        return;
    }

    // 1️⃣ Normaliza e cria fillObj
    array1.forEach(obj => {
        if (!obj.fill || obj["xlink:href"]) return;

        const el = document.createElement("div");
        el.style.backgroundColor = obj.fill;
        document.body.appendChild(el);

        const normalized = getComputedStyle(el).backgroundColor;
        document.body.removeChild(el);

        obj.fill = normalized;
        obj.fillObj = rgbStringToObj(normalized);
    });

    // 2️⃣ Agrupa cores semelhantes
    const groups = groupColorsWithMap(array1, 25);

    // 3️⃣ Reaplica cor representante
    applyGroupedColors(groups);

    // 4️⃣ Extrai cores únicas finais
    const used = new Set();
    array1.forEach(obj => {
        if (obj.fill && !obj["xlink:href"] && !used.has(obj.fill)) {
            used.add(obj.fill);
            array2.push(obj.fill);
        }
    });

    // 5️⃣ Render UI
    array2.forEach(color => {
        const elem =
            "<div class='color-iframe-main' " +
            "data-ini='" + color + "' " +
            "data-part='" + part + "' " +
            "style='background-color: " + color + "'>" +
            "</div>";

        $(id).append(elem);
    });
}


$("body").on("click", ".color-iframe-main", function () {
    $(".cores-iframe").css("display", "none");
    $("#cores-iframe-table").css("display", "block");

    $("#title-part-cor").text("Cor Atual " + $(this).data("part") + ":");
    $("#current-color div").css("background-color", $(this).css("background-color"))
    currentColorPart = $(this);

    window.backColor = true;

    if (currentColorPart.data("part") == "camisa")
        focusColorPart("camisa");
    else if (currentColorPart.data("part") == "short")
        focusColorPart("short");
    else if (currentColorPart.data("part") == "meia")
        focusColorPart("MEIÃO");

    $("#cores-iframe-table-list").empty();

    var part = currentColorPart.data("part");

    if (part == "short") part = "calcao";

    var populatedColors = false;

    for (var i = 0; i < window.colors.length; i++) {

        if (window.dataShared.colors[part] == window.colors[i].id) {
            populatedColors = true;
            for (var j = 0; j < window.colors[i].colors.length; j++) {
                const elem = "<div class='cor-tabela' style='background-color: " + window.colors[i].colors[j].hex + "'>" +
                    "</div>";

                $("#cores-iframe-table-list").append(elem);
            }
        }
    }

    if (!populatedColors) {
        if (window.dataShared.mainColorTable) {
            for (var i = 0; i < window.colors.length; i++) {

                if (window.dataShared.mainColorTable == window.colors[i].id) {
                    for (var j = 0; j < window.colors[i].colors.length; j++) {
                        const elem = "<div class='cor-tabela' style='background-color: " + window.colors[i].colors[j].hex + "'>" +
                            "</div>";

                        $("#cores-iframe-table-list").append(elem);
                    }
                }
            }
        }
    }
});

$("body").on("click", ".color-iframe-main-grad", function () {
    $(".cores-iframe").css("display", "none");
    $("#cores-iframe-table-grad").css("display", "block");
    /*$("#cores-iframe-table").css("display", "block");

    $("#title-part-cor").text("Cor Atual " + $(this).data("part") + ":");
    $("#current-color div").css("background-color", $(this).css("background-color"))
    currentColorPart = $(this);*/

    indexGrad = $(this).data("id");

    //trabalhando

    $("#iframe-color-stops").empty();
    $("#cores-iframe-table-list-grad").css("display", "none");

    for (var i = 0; i < gradientArray[indexGrad].fill.colorStops.length; i++) {

        const elem = "<div data-index='" + i + "' style='background: " + gradientArray[indexGrad].fill.colorStops[i].color + "'></div>"

        $("#iframe-color-stops").append(elem);
    }

    gradElem = $(this);
});

var indexGrad;

function focusColorPart(part) {
    const box = new Box3().setFromObject(window.model.getObjectByName(part));
    const center = new Vector3();
    box.getCenter(center);

    center.z += 0.1;

    window["focusCameraOnPoint"](center, window.model, 1.5, 0.35);
}

$("body").on("click", "#back-color-table", function () {
    $(".cores-iframe").css("display", "flex");
    $("#cores-iframe-table").css("display", "none");
    window["setupCamera"]();
});

$("body").on("click", "#back-color-table-grad", function () {
    $(".cores-iframe").css("display", "flex");
    $("#cores-iframe-table-grad").css("display", "none");
    window["setupCamera"]();
});

function hasBackgroundColor(parent, color) {
    const children = parent.children;

    for (let i = 0; i < children.length; i++) {
        const style = window.getComputedStyle(children[i]);
        const bg = style.backgroundColor;

        // verifica se NÃO é transparente
        if (bg == color) {
            return true;
        }
    }

    return false;
}

$("body").on("click", ".cor-tabela", function () {
    $("#current-color div").css("background-color", $(this).css("background-color"))
    currentColorPart.css("background-color", $(this).css("background-color"))

    if (!hasBackgroundColor(document.querySelector('#current-used-colors'), $(this).css("background-color"))) {
        var elemColor = "<div style='background-color: " + $(this).css("background-color") + "'></div>"

        $("#current-used-colors").append(elemColor);
    }

    if (currentColorPart.data("part") == "camisa") {
        for (var i = 0; i < corCamisaArray.length; i++) {
            if (corCamisaArray[i].fillIni == currentColorPart.data("ini")) {
                corCamisaArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    } else if (currentColorPart.data("part") == "short") {
        for (var i = 0; i < corShortArray.length; i++) {
            if (corShortArray[i].fillIni == currentColorPart.data("ini")) {
                corShortArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    } else if (currentColorPart.data("part") == "meia") {
        for (var i = 0; i < corMeiaArray.length; i++) {
            if (corMeiaArray[i].fillIni == currentColorPart.data("ini")) {
                corMeiaArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    } else if (currentColorPart.data("part") == "gola") {
        for (var i = 0; i < corGolaArray.length; i++) {
            if (corGolaArray[i].fillIni == currentColorPart.data("ini")) {
                corGolaArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    } else if (currentColorPart.data("part") == "manga") {
        for (var i = 0; i < corMangaArray.length; i++) {
            if (corMangaArray[i].fillIni == currentColorPart.data("ini")) {
                corMangaArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    } else {
        for (var i = 0; i < corOutrosArray.length; i++) {
            if (corOutrosArray[i].fillIni == currentColorPart.data("ini")) {
                corOutrosArray[i].set({
                    fill: $(this).css("background-color"),
                });
            }
        }
    }

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
});

function getColorByPart(objs, id) {

    window.fabricCanvas.getObjects().forEach(obj => {
        const result = extractObjects(obj);
        texts.push(...result.texts);
        images.push(...result.images);
    });

    window.arrayGroupTexts = texts;

    texts.forEach(img => {
        // Remove a imagem do canvas caso ainda esteja
        if (img.group) {
            img.group.removeWithUpdate(img); // Remove do grupo
        }
        window.fabricCanvas.remove(img); // Remove do canvas, se ainda estiver
    });

    for (var i = 0; i < texts.length; i++) {

        window.fabricCanvas.add(texts[i]);

        const center = texts[i].getCenterPoint();
        texts[i].set({
            textAlign: 'center',
            originX: 'center',
            new_id: Math.random()
        });
        texts[i].setPositionByOrigin(center, 'center', 'center');

        var elem = "<div class='thumb-text-iframe iframe-text-edit' data-index='" + i + "'>" +
            "<span style='color: " + texts[i].fill + ";font-family: " + texts[i].fontFamily + "'>" + texts[i].text + "</span>" +
            "</div>";

        $("#iframe-text-items").append(elem);

        window.fontFamily = texts[i].fontFamily;
    }

    window.imagesIframe = images;

    images.forEach(img => {
        // Remove a imagem do canvas caso ainda esteja
        if (img.group) {
            img.group.removeWithUpdate(img); // Remove do grupo
        }
        window.fabricCanvas.remove(img); // Remove do canvas, se ainda estiver
    });

    arrayGroupLogos = [];

    // Cada logo/imagem extraído do SVG vira uma entrada PRÓPRIA no menu —
    // mesmo que vários compartilhem o mesmo id (ex: dois <image id="logo">),
    // não podem ser unificados num grupo só.
    for (var i = 0; i < images.length; i++) {
        // Cria o grupo
        const logoGroup = new fabric.Group([images[i]]);

        logoGroup.set({
            new_id: Math.random()
        });

        // Adiciona o grupo ao canvas
        window.fabricCanvas.add(logoGroup);

        arrayGroupLogos.push(logoGroup);
    }

    // ⚠️ Precisa vir ANTES do svgColorsReady dispatch: o LogoPicker React
    // escuta esse evento e lê window.arrayGroupLogos na hora — se o window
    // ainda apontar para o array antigo/vazio, o grid fica vazio até o
    // usuário sair e voltar da tab (refresh do mount).
    window.arrayGroupLogos = arrayGroupLogos;

    /*for (var i = 0; i < window.fabricCanvas._objects[0]._objects.length; i++) {

        var type;

        if (window.fabricCanvas._objects[0]._objects[i].id) {

            if (window.fabricCanvas._objects[0]._objects[i].id.includes("CAM"))
                type = "camisa";
            else if (window.fabricCanvas._objects[0]._objects[i].id.includes("SHO"))
                type = "short";
            else if (window.fabricCanvas._objects[0]._objects[i].id.includes("GOLA"))
                type = "gola";
            else if (window.fabricCanvas._objects[0]._objects[i].id.includes("MEIA"))
                type = "meia";
            else
                type = "outros";

            if (type) {
                window.fabricCanvas._objects[0]._objects[i].getObjects().forEach(obj => {
                    extractObjectsColors(obj, type)
                });
            }
        }
    }*/

    window.fabricCanvas._objects[0].getObjects().forEach(obj => {
        extractObjectsColors(obj, "")
    });

    organizeColors(corGolaArray, uniCorGolaArray, "#cores-iframe-gola-list", "gola")
    organizeColors(corCamisaArray, uniCorCamisaArray, "#cores-iframe-camisa-list", "camisa")
    organizeColors(corMangaArray, uniCorMangaArray, "#cores-iframe-manga-list", "manga")
    organizeColors(corShortArray, uniCorcorShortArray, "#cores-iframe-short-list", "short")
    organizeColors(corMeiaArray, uniCorcorMeiaArray, "#cores-iframe-meia-list", "meia")

    organizeColors(corOutrosArray, uniCorcorOutrosArray, "#cores-iframe-outros-list", "outros")

    // Expõe arrays no window para o ColorPicker React conseguir ler
    window.uniCorGolaArray       = uniCorGolaArray;
    window.uniCorCamisaArray     = uniCorCamisaArray;
    window.uniCorMangaArray      = uniCorMangaArray;
    window.uniCorcorShortArray   = uniCorcorShortArray;
    window.uniCorcorMeiaArray    = uniCorcorMeiaArray;
    window.uniCorcorOutrosArray  = uniCorcorOutrosArray;

    // Arrays de objetos Fabric (para aplicar mudanças de cor)
    window.corGolaArray   = corGolaArray;
    window.corCamisaArray = corCamisaArray;
    window.corMangaArray  = corMangaArray;
    window.corShortArray  = corShortArray;
    window.corMeiaArray   = corMeiaArray;
    window.corOutrosArray = corOutrosArray;

    // Notifica o React que as cores estão prontas
    window.dispatchEvent(new Event("svgColorsReady"));

    setupGrad();

    for (var i = 0; i < arrayGroupLogos.length; i++) {

        const dataURL = arrayGroupLogos[i].toDataURL({ format: 'png', multiplier: 2 });

        // data-edit='1' libera as opções completas (escala, rotação, deletar,
        // substituir) no painel de edição — igual às logos enviadas por upload.
        var elem = "<div class='thumb-logo-iframe iframe-logo-edit' data-edit='1' data-index='" + i + "'>" +
            "<div style='background-image: url(" + dataURL + ")'></div>" +
            "</div>";

        $("#iframe-logos-items").append(elem);
    }

    // Atualiza a tela
    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
}

function setupGrad() {
    if (gradientArray.length == 0) {
        $("#cores-iframe-grad").css("display", "none");
        return;
    }

    $("#cores-iframe-grad").css("display", "block");

    // 5️⃣ Render UI
    gradientArray.forEach(obj => {

        const grad = fabricGradientToCSS(obj.fill)

        const elem =
            "<div class='color-iframe-main-grad' data-id='" + obj.gradID + "'" +
            "style='background: " + grad + "'>" +
            "</div>";

        $("#cores-iframe-grad-list").append(elem);
    });
}

function fabricLinearGradientToCSS(gradient) {
    const angle = linearGradientAngle(gradient.coords);
    const stops = gradientStopsToCSS(gradient);
    return `linear-gradient(${angle}deg, ${stops})`;
}

function fabricRadialGradientToCSS(gradient) {
    const stops = gradientStopsToCSS(gradient);
    return `radial-gradient(circle, ${stops})`;
}

function linearGradientAngle(coords) {
    const dx = coords.x2 - coords.x1;
    const dy = coords.y2 - coords.y1;

    let angle = Math.atan2(dy, dx) * (180 / Math.PI);
    angle = (angle + 90 + 360) % 360; // CSS orientation

    return angle;
}

function gradientStopsToCSS(gradient) {
    return Object.entries(gradient.colorStops)
        .sort((a, b) => a[0] - b[0])
        .map(([offset, stop]) => {
            return `${stop.color} ${Math.round(offset * 100)}%`;
        })
        .join(", ");
}


$("body").on("input", ".text-iframe", function () {

    texts[$(this).data("id")].text = $(this).val();

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
});

$("body").on("input", ".checkObjState", function () {
    const index = $(this).parent().parent().parent().data("id");

    window.imagesIframe[index].visible = $(this).prop("checked");

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
});

$("body").on("click", ".deleteObjIframe", function () {

    const index = $(this).parent().parent().parent().data("id");

    window.fabricCanvas.remove(window.imagesIframe[index])

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();

    $(this).parent().parent().parent().remove();
});

$("body").on("input", ".scaleObjValue", function () {
    const index = $(this).parent().parent().parent().data("id");

    window.imagesIframe[index].scaleX = window.imagesIframe[index].scaleXIni * $(this).val();
    window.imagesIframe[index].scaleY = window.imagesIframe[index].scaleYIni * $(this).val();

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
});

$("body").on("input", ".rotateObjValue", function () {
    const index = $(this).parent().parent().parent().data("id");

    window.imagesIframe[index].angle = $(this).val();

    window.fabricCanvas.renderAll();
    window["updateCanvas"]();
});

$("body").on("change", ".changeLogoIframe", function () {

    const index = $(this).parent().parent().parent().data("id");
    const thumb = $(this).parent().parent().parent().find(".image-iframe-src");

    var fileReader = new FileReader();
    fileReader.onload = function () {
        var data = fileReader.result;  // data <-- in this var you have the file data in Base64 format

        const imgElement = new Image();
        imgElement.src = data;

        thumb.css("background-image", "url(" + data + ")");

        imgElement.onload = () => {

            // Get old visible size
            const oldHeight = window.imagesIframe[index].height * window.imagesIframe[index].scaleY;

            window.imagesIframe[index].setElement(imgElement);

            // Calculate new scale to match the old height
            const newScale = oldHeight / imgElement.height;

            // Set new intrinsic size
            window.imagesIframe[index].set({
                width: imgElement.width,
                height: imgElement.height,
                scaleX: newScale,
                scaleY: newScale
            });

            window.fabricCanvas.renderAll();
            window["updateCanvas"]();
        };
    };
    fileReader.readAsDataURL($(this).prop('files')[0]);
});

//iframe-color-stops div

var indexColorStep, colorStepElem, gradElem;

$("body").on("click", "#iframe-color-stops div", function () {

    $("#iframe-color-stops div").css("border", "none");
    $("#cores-iframe-table-list-grad").css("display", "flex");
    $(this).css("border", "3px solid");

    indexColorStep = $(this).data("index");
    colorStepElem = $(this);
});

//cor-tabela-grad

$("body").on("click", ".cor-tabela-grad", function () {

    const color = $(this).css("background-color");

    if ($("#state-grad-all").prop("checked")) {

        for (var i = 0; i < gradientArray[indexGrad].fill.colorStops.length; i++) {

            gradientArray[indexGrad].fill.colorStops[i].color = color;
            $("#iframe-color-stops div").css("background", color);

        }
    } else {
        gradientArray[indexGrad].fill.colorStops[indexColorStep].color = color;
        colorStepElem.css("background", color)
    }

    const grad = fabricGradientToCSS(gradientArray[indexGrad].fill);

    gradElem.css("background", grad)

    window.fabricCanvas.requestRenderAll();

    setTimeout(() => {
        window["updateCanvas"]();
    }, 100);

})

function fabricGradientToCSS(grad) {
    const stops = grad.colorStops
        .slice()
        .sort((a, b) => a.offset - b.offset)
        .map(s => {
            const rgb = s.color.match(/\d+/g).map(Number);
            const alpha = s.opacity ?? 1;
            const color = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${alpha})`;
            const pct = Math.round(s.offset * 100);
            return `${color} ${pct}%`;
        });

    if (grad.type === "linear") {
        const { x1, y1, x2, y2 } = grad.coords;
        const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI + 90;

        return `linear-gradient(${Math.round(angle)}deg, ${stops.join(", ")})`;
    }

    if (grad.type === "radial") {
        return `radial-gradient(circle, ${stops.join(", ")})`;
    }
}


export { addColorSvgIframe }